import { render, staticRenderFns } from "./examine-detail.vue?vue&type=template&id=5bf25e3a&scoped=true&"
import script from "./examine-detail.vue?vue&type=script&lang=js&"
export * from "./examine-detail.vue?vue&type=script&lang=js&"
import style0 from "./examine-detail.vue?vue&type=style&index=0&id=5bf25e3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf25e3a",
  null
  
)

export default component.exports